const Competitors = Vue.component('competitors', {
    template: `
        <div>
            <div class="row title">
                <div class="col">
                    <h4 style="display: inline">
                        {{ $language.familyNum.replace('[FAMILYNUMBER]', family) }}&nbsp;<i class="fas fa-angle-right"></i>&nbsp;{{ $language.competitors }}
                    </h4>
                    <span v-if="from">
                        &nbsp;({{ $language.basedon[from] }})
                    </span>
                </div>
            </div>

            <div class="main" id="competitors">
                <div class="col-12 tuto" v-if="from">
                    {{ $language.clickComp }}
                </div>
                <div class="row links" v-if="competitors.length > 0">
                    <div class="col">
                        <div class="link" v-for="competitor in competitors" v-if="competitor.ProbablePA">
                            <router-link class="listItem" active-class="currentPage" :to="'/' + family + '/assignees/' + competitor.ProbablePA">
                                {{ competitor.ProbablePA }}&nbsp;({{ competitor.cite_count }}&nbsp;{{ (from == 'citations')?$language.citations:$language.publications }})
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12">
                        {{ $language.compNotFound }}
                    </div>
                </div>
                <template v-if="selfCite.length > 0">
                    <hr />
                    Self citations:
                    <div class="col links">
                        <div class="link" v-for="competitor in selfCite" v-if="competitor.ProbablePA">
                            <router-link class="listItem" active-class="currentPage" :to="'/' + family + '/assignees/' + competitor.ProbablePA">
                                {{ competitor.ProbablePA }}&nbsp;({{ competitor.cite_count }}&nbsp;{{ $language.citations }})
                            </router-link>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    `,

    computed: {
        family() {
            return this.$route.params.family;
        },

        pa() {
            return this.$store.getters.pa;
        },

        competitors() {
            return this.$store.state.competitors.filter(competitor => {
                if (this.from == 'citations') {
                    return competitor.ProbablePA != this.pa;
                } else {
                    return true;
                }
            });
        },

        selfCite() {
            return this.$store.state.competitors.filter(competitor => {
                if (this.from == 'citations') {
                    return competitor.ProbablePA == this.pa;
                } else {
                    return false;
                }
            });
        }
    },
    data: function() {
        return {
            from: '',
            loggedUser
        };
    },

    mounted: function() {
        this.$store.commit('addLoadedComponent', 'Competitors');

        EventBus.$on('newFamily', () => {
            this.getCompetitors();
        });

        this.getCompetitors();

    },

    methods: {
        getCompetitors() {

            //get competitors
            axios.get('?page=getData&action=getCompetitors', {
                    params: {
                        family: this.family
                    }
                })
                .then(response => {

                    let competitors = [];

                    this.$store.commit('saveCompetitors', response.data.competitors);
                    this.from = response.data.from;

                    this.$store.commit('hideLoading');

                })
                .catch(function(err) {
                    console.log(err);
                });

        },

        getCite(ppa) {

            axios.get('?page=getData&action=getCite', {
                    params: {
                        family: this.family,
                        ppa,
                        from: this.from
                    }
                })
                .then(response => {

                    let families = response.data.families.map(family => {
                        return family.MasterID;
                    });

                    patbase.searchFamilies(families, images.getSetupPath() + '../');

                })
                .catch(function(err) {
                    console.log(err);
                });

        }
    }
});
